import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { InferType, object, string } from 'yup';
import i18n from '@i18n/config';

const t = (key: string): string =>
  i18n.t(`validation:${key}` as unknown as TemplateStringsArray);

const loginSchema = object({
  courriel: string()
    .email(t('login.emailValid'))
    .required(t('login.emailRequired')),
  password: string().required(t('login.passwordRequired')),
});


export type LoginRequest = InferType<typeof loginSchema> & { recaptchaToken?: string };
export interface LoginResponse {
  prenom: string;
  nom: string;
  token: string;
  idClient: number;
  id: number;
}

export const useLoginForm = () => useForm<LoginRequest>({ resolver: yupResolver(loginSchema) });
